import { useNavigate } from 'react-router-dom';
import {
  useWorkflow,
  getNextScreen,
  getPreviousScreen,
  getCurrentStepNumber,
  calculateTotalSteps,
} from '@sluitstraat/core';
import { getProductOrder } from '../workflowConfig';
import type { SaaProductId } from '../utils/addressSharing';

// Centralises the workflow-navigation boilerplate every product screen repeats: the step
// counter (for WorkflowPageLayout), the product counter (for the nav), and go-to-next/previous
// navigation. Pass the screen id (= product key = route segment, e.g. 'rechtsbijstand').
export function useWorkflowNav(screenId: SaaProductId) {
  const navigate = useNavigate();
  const { selectedProducts } = useWorkflow();
  const route = `/workflow/${screenId}`;

  const currentStep = getCurrentStepNumber(route, selectedProducts);
  const totalSteps = calculateTotalSteps(selectedProducts);

  const productList = getProductOrder().filter((p) => selectedProducts?.[p]);
  const productIndex = productList.indexOf(screenId) + 1;
  const totalProducts = productList.length;

  const goToNext = () => {
    const next = getNextScreen(route, selectedProducts);
    if (next) navigate(next);
  };
  const goToPrevious = () => {
    const prev = getPreviousScreen(route, selectedProducts);
    if (prev) navigate(prev);
  };

  return { currentStep, totalSteps, productIndex, totalProducts, goToNext, goToPrevious };
}
